import React from 'react';
import { useSession } from '@supabase/auth-helpers-react';

const getInitials = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) return 'EM';
  const parts = trimmed.split(/\s+/).slice(0, 2);
  return parts.map((part) => part[0]?.toUpperCase() || '').join('') || 'EM';
};

const EmployerHeader: React.FC = () => {
  const session = useSession();
  const companyName =
    (session?.user?.app_metadata?.companyName as string | undefined) ||
    (session?.user?.app_metadata?.company as string | undefined) ||
    'Employer Account';
  const userName =
    (session?.user?.app_metadata?.preferredName as string | undefined) ||
    session?.user?.email?.split('@')[0] ||
    'Employer';
  const avatarInitials = getInitials(userName);

  return (
    <header className="w-full bg-[#0d9488] px-8 h-14 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-[12px] bg-white/20 text-[19px] font-bold text-white">I</div>
        <p className="font-display text-[24px] font-bold tracking-[0.04em] text-white">INTELLERVIEW</p>
      </div>
      <div className="flex items-center gap-3">
        <p className="text-[13px] text-white/75">{companyName}</p>
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-[11px] font-bold text-white">{avatarInitials}</div>
      </div>
    </header>
  );
};

export default EmployerHeader;
